import { useRef } from 'react'

import { Box, Card, Section, TogglerCheckbox } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'

import type {
  default as Survey,
  default as SurveyForm,
} from 'modules/surveys/store/models/v2/Survey'

interface Props {
  form: SurveyForm | Survey
  canBeAnonymous: boolean
}

function PrivacySetting({ form: surveyForm, canBeAnonymous }: Props) {
  const hasAnswers = surveyForm.answeredQuestionsCount > 0
  // currently survey v2 is shown as "draft", even when active or finished
  // and answeredQuestionCount is always 0 as the current cycle is not set
  const disabled = surveyForm.isFinished || !canBeAnonymous || hasAnswers
  const title = i18n.t('surveys.form.basic_info.form.labels.anonymous')
  const description = i18n.t('surveys.form.basic_info.anonymous.disable_anonymous_description')

  const form = useRef(
    new Form(surveyForm.toJS(), {
      anonymous: 'boolean',
    })
  ).current

  const onToggle = () => {
    form.setValues({
      anonymous: !form.get('anonymous').value,
    })
    submit()
  }

  const { performAction: submit } = useAsyncAction(() => form.save(surveyForm))

  return (
    <Section
      illustration="visibility"
      title={i18n.t('surveys.form.basic_info.anonymous.title')}
      description={i18n.t('surveys.form.basic_info.anonymous.subtitle')}
    >
      <Box gap="s16" aria-label="Here you can set your privacy settings">
        <Card>
          <Card.Title
            size="small"
            action={
              <TogglerCheckbox
                value={form.get('anonymous').value}
                onChange={onToggle}
                disabled={disabled}
              />
            }
          >
            {title}
          </Card.Title>
          <Card.Description>{description}</Card.Description>
        </Card>
      </Box>
    </Section>
  )
}

export default observer(PrivacySetting)
